import {
  AddFieldsButton,
  AddFieldsButtonProps,
  FieldSearchBar,
  FieldSearchChips,
} from '@cibo/landmanager'
import AddIcon from '@mui/icons-material/Add'
import { Stack, StackProps, Typography } from '@mui/material'

interface FieldTableHeaderProps {
  title?: string
  addFieldsButtonProps?: AddFieldsButtonProps
  parentStackProps?: StackProps
}

export const FieldTableHeader = ({
  title,
  addFieldsButtonProps,
  parentStackProps,
}: FieldTableHeaderProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={2}
    {...parentStackProps}
  >
    <Stack sx={{ flex: 1 }}>
      <Stack direction="row" spacing={2} alignItems="center">
        {!!title && <Typography fontSize={20}>{title}</Typography>}
      </Stack>

      <FieldSearchChips />
    </Stack>

    <Stack direction="row" spacing={1}>
      <FieldSearchBar />
      <AddFieldsButton
        startIcon={<AddIcon />}
        size="medium"
        variant="contained"
        sx={{ marginBlock: '4px !important' }}
        {...addFieldsButtonProps}
      />
    </Stack>
  </Stack>
)
